<template>
    <WarningDeleteUser v-if="errorDeleteUser"/>
    <Title :title="title"/>
    <div class="container-form">
        <form class="user-create-form" ref="createUserForm">
            <legend>Seleccione el usuario que desea eliminar</legend>
            <div style="margin-top: 3rem; margin-bottom: 1rem;">
                <label>Correo</label>
                 <select name='userId' id='userId' v-model='userId' ref="selected">
                    <option
                        value="" disabled>
                        {{defaultValue}}
                    </option>
                    <option
                        v-for="user in userList"
                        :key="user.id"
                        :value="user.id">
                        {{user.email}}
                    </option>
                 </select>
            </div>
            <div v-if="userId !== ''">
                <p>EL USUARIO SELECCIONADO ES:</p>
                <div class="container-right">
                    <div class="input-container">
                        <label>Nombre</label>
                        <input v-model="selectedUser.name" type="text" disabled/>
                    </div>
                    <div class="input-container">
                        <label>Documento de identificación</label>
                        <input v-model="selectedUser.identification_document" type="text" disabled/>
                    </div>
                </div>
                <div class="container-left">
                    <div class="input-container">
                        <label>Apellido:</label>
                        <input type="text" v-model="selectedUser.lastname" disabled>
                    </div>
                    <div class="input-container">
                        <label>Institución:</label>
                        <input type="text" v-model="selectedUser.institution" disabled>
                    </div>
                </div>
                <button class="button-save" @click.prevent="deleteUserConfirm()">Eliminar</button>
            </div>
        </form>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Title from '../../../components/ViewsTitle/ViewsTitle.vue'
import WarningDeleteUser from '../../Warning/WarningDeleteUser.vue'
import router from '../../../router';

export default {
    name: 'DeleteUserForm',
    data(){
        return {
            title: 'BORRAR USUARIO',
            defaultValue: 'Seleccione el correo',
            userId: '',
            userAction: 'Delete'
        }
    },
    created() {
        this.getUsers()
    },
    components: {
        Title,
        WarningDeleteUser
    },
    computed: {
        ...mapState(['userList', 'errorDeleteUser']),
        selectedUser() {
            return this.userList[this.userId] || {};
        }
    },
    methods: {
        ...mapActions(['getUsers', 'deleteUser']),
        async deleteUserConfirm(){
            try {
                await this.deleteUser(this.userId)
                if(!this.errorDeleteUser){
                    router.push('/')
                    this.$store.commit('change_user_action', this.userAction)
                }
                this.userId = ''
            } catch (error) {
                console.log(error)
            }
        }
    },
}
</script>
<style scoped>
.container-form {
    font-family: "Ancizar-regular", Helvetica, Arial;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.user-create-form {
    width: 35rem;
    box-sizing: border-box;
    border: 0.15rem solid rgb(100, 120, 20);
    border-radius: .5rem;
    margin-left: 5rem;
}
.input-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.container-right, .container-left {
    display: inline-block;
}
.container-left {
    margin-left: .5rem;
}
legend {
    background-color: rgb(100, 120, 20);
    color:white;
    font-size: 1.3rem;
    padding: .3rem .2rem .3rem 2rem;
    line-height: 1.2;
}
label{
    font-size: 1rem;
    padding: .5rem 0rem 0rem 2rem;
}
p {
    font-size: 1.1rem;
    margin: 1rem 0rem 0rem 2rem;
    color:rgb(91, 109, 18);
    font-weight: bold;
}
input, select {
    margin: .2rem 0rem .5rem 2rem;
    height: 2rem;
    width: 14rem;
    border: 1px solid rgba(55, 55, 55, 0.7);
    border-radius: .5rem;
    padding-left: .5rem ;
}
select {
    margin: .2rem 0rem 0rem 1rem;
}
.button-save {
    width: 10rem;
    color: white;
    height: 2.5em;
    background-color: rgb(100, 120, 20);
    border-radius: .3rem;
    font-size: 1.1rem;
    margin: 1rem 0rem .8rem 2rem;
}
</style>